export const FrontDocumentScanImage: any = {
  v: '5.5.2',
  fr: 25,
  ip: 0,
  op: 125,
  w: 160,
  h: 165,
  nm: 'Validación Cédula_01',
  ddd: 1,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Capa 3 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            r: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                    ],
                    y: [
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                    ],
                    y: [
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    42,
                  ],
                },
                {
                  t: 17,
                  s: [
                    0,
                  ],
                },
              ],
              ix: 10,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                65.568,
                63.76,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 8,
                  s: [
                    5,
                    5,
                    100,
                  ],
                },
                {
                  t: 22,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.501,
                        ],
                        [
                          -1.501,
                          0,
                        ],
                        [
                          0,
                          -1.501,
                        ],
                        [
                          1.5,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      128.168,
                      124.554,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.003,
                          -0.553,
                        ],
                        [
                          0.434,
                          -0.168,
                        ],
                        [
                          0.769,
                          -2.139,
                        ],
                        [
                          0.46,
                          0.008,
                        ],
                        [
                          0.184,
                          0.525,
                        ],
                        [
                          1.227,
                          0.861,
                        ],
                        [
                          0.588,
                          0.27,
                        ],
                        [
                          0.025,
                          0.489,
                        ],
                        [
                          -0.512,
                          0.201,
                        ],
                        [
                          -0.756,
                          2.107,
                        ],
                        [
                          -0.468,
                          0.003,
                        ],
                        [
                          -0.203,
                          -0.564,
                        ],
                        [
                          -2.063,
                          -0.815,
                        ],
                      ],
                      o: [
                        [
                          -0.009,
                          0.445,
                        ],
                        [
                          -2.119,
                          0.819,
                        ],
                        [
                          -0.188,
                          0.522,
                        ],
                        [
                          -0.454,
                          -0.007,
                        ],
                        [
                          -0.494,
                          -1.417,
                        ],
                        [
                          -0.527,
                          -0.37,
                        ],
                        [
                          -0.438,
                          -0.201,
                        ],
                        [
                          -0.023,
                          -0.45,
                        ],
                        [
                          2.085,
                          -0.817,
                        ],
                        [
                          0.19,
                          -0.53,
                        ],
                        [
                          0.488,
                          -0.004,
                        ],
                        [
                          0.754,
                          2.089,
                        ],
                        [
                          0.458,
                          0.181,
                        ],
                      ],
                      v: [
                        [
                          6.003,
                          0.027,
                        ],
                        [
                          5.32,
                          0.948,
                        ],
                        [
                          0.99,
                          5.384,
                        ],
                        [
                          0.001,
                          6.148,
                        ],
                        [
                          -0.973,
                          5.356,
                        ],
                        [
                          -3.527,
                          1.902,
                        ],
                        [
                          -5.234,
                          0.979,
                        ],
                        [
                          -5.98,
                          0.014,
                        ],
                        [
                          -5.23,
                          -0.989,
                        ],
                        [
                          -0.975,
                          -5.375,
                        ],
                        [
                          0.008,
                          -6.152,
                        ],
                        [
                          1.012,
                          -5.349,
                        ],
                        [
                          5.242,
                          -0.997,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      6.253,
                      6.406,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 8,
          op: 758,
          st: 8,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 3,
          ty: 4,
          nm: 'Capa 4 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 0,
              k: [
                78.753,
                81.23,
                0,
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                36.864,
                77.068,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 9,
                  s: [
                    19,
                    19,
                    19,
                  ],
                },
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 17,
                  s: [
                    113,
                    113,
                    113,
                  ],
                },
                {
                  t: 26,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.536,
                          -0.807,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          0.537,
                          0.807,
                        ],
                        [
                          0.465,
                          0.7,
                        ],
                      ],
                      o: [
                        [
                          0.465,
                          0.7,
                        ],
                        [
                          0.532,
                          0.8,
                        ],
                        [
                          -0.464,
                          -0.7,
                        ],
                        [
                          -0.531,
                          -0.801,
                        ],
                      ],
                      v: [
                        [
                          -1.345,
                          -0.671,
                        ],
                        [
                          0.049,
                          1.429,
                        ],
                        [
                          1.344,
                          0.672,
                        ],
                        [
                          -0.05,
                          -1.428,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.131,
                      151.657,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.873,
                          0.414,
                        ],
                        [
                          1.753,
                          1.8,
                        ],
                        [
                          -0.673,
                          -0.692,
                        ],
                        [
                          -2.38,
                          -1.128,
                        ],
                      ],
                      o: [
                        [
                          -2.271,
                          -1.076,
                        ],
                        [
                          -0.675,
                          -0.693,
                        ],
                        [
                          1.838,
                          1.887,
                        ],
                        [
                          0.868,
                          0.412,
                        ],
                      ],
                      v: [
                        [
                          3.45,
                          1.646,
                        ],
                        [
                          -2.588,
                          -2.66,
                        ],
                        [
                          -3.65,
                          -1.6,
                        ],
                        [
                          2.693,
                          2.942,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      69.155,
                      3.604,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 9,
          op: 759,
          st: 9,
          bm: 0,
        },
        {
          ddd: 1,
          ind: 5,
          ty: 4,
          nm: 'Capa 1 contornos',
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11,
            },
            rx: {
              a: 0,
              k: 0,
              ix: 8,
            },
            ry: {
              a: 0,
              k: 0,
              ix: 9,
            },
            rz: {
              a: 0,
              k: 0,
              ix: 10,
            },
            or: {
              a: 0,
              k: [
                0,
                0,
                0,
              ],
              ix: 7,
            },
            p: {
              a: 1,
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 0.768,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  t: 0,
                  s: [
                    78.571,
                    80.759,
                    42,
                  ],
                  to: [
                    0,
                    0,
                    -5.569,
                  ],
                  ti: [
                    0,
                    0,
                    11.003,
                  ],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0.396,
                  },
                  t: 15,
                  s: [
                    78.571,
                    80.759,
                    -8.936,
                  ],
                  to: [
                    0,
                    0,
                    -2.826,
                  ],
                  ti: [
                    0,
                    0,
                    1.431,
                  ],
                },
                {
                  t: 20,
                  s: [
                    78.571,
                    80.759,
                    0,
                  ],
                },
              ],
              ix: 2,
            },
            a: {
              a: 0,
              k: [
                72.688,
                71.924,
                0,
              ],
              ix: 1,
            },
            s: {
              a: 1,
              k: [
                {
                  i: {
                    x: [
                      0.667,
                      0.667,
                      0.667,
                    ],
                    y: [
                      1,
                      1,
                      1,
                    ],
                  },
                  o: {
                    x: [
                      0.333,
                      0.333,
                      0.333,
                    ],
                    y: [
                      0,
                      0,
                      0,
                    ],
                  },
                  t: 0,
                  s: [
                    11,
                    11,
                    11,
                  ],
                },
                {
                  t: 5,
                  s: [
                    100,
                    100,
                    100,
                  ],
                },
              ],
              ix: 6,
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.501,
                          -0.829,
                        ],
                        [
                          -1.184,
                          -0.353,
                        ],
                        [
                          0.925,
                          0.276,
                        ],
                        [
                          0.436,
                          0.723,
                        ],
                      ],
                      o: [
                        [
                          0.64,
                          1.057,
                        ],
                        [
                          0.926,
                          0.276,
                        ],
                        [
                          -0.809,
                          -0.241,
                        ],
                        [
                          -0.499,
                          -0.825,
                        ],
                      ],
                      v: [
                        [
                          -1.813,
                          -0.431,
                        ],
                        [
                          0.991,
                          1.737,
                        ],
                        [
                          1.389,
                          0.29,
                        ],
                        [
                          -0.517,
                          -1.188,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      142.813,
                      54.545,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 1',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          1.5,
                        ],
                        [
                          -1.5,
                          0,
                        ],
                        [
                          0,
                          -1.5,
                        ],
                        [
                          1.501,
                          0,
                        ],
                      ],
                      v: [
                        [
                          2.717,
                          0,
                        ],
                        [
                          0,
                          2.717,
                        ],
                        [
                          -2.717,
                          0,
                        ],
                        [
                          0,
                          -2.717,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      133.255,
                      44.064,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 2',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0.483,
                          0.839,
                        ],
                        [
                          0.048,
                          0.698,
                        ],
                        [
                          -0.067,
                          -0.965,
                        ],
                        [
                          -0.484,
                          -0.84,
                        ],
                      ],
                      o: [
                        [
                          -0.348,
                          -0.604,
                        ],
                        [
                          -0.066,
                          -0.957,
                        ],
                        [
                          0.067,
                          0.966,
                        ],
                        [
                          0.482,
                          0.836,
                        ],
                      ],
                      v: [
                        [
                          0.846,
                          0.66,
                        ],
                        [
                          0.238,
                          -1.288,
                        ],
                        [
                          -1.262,
                          -1.288,
                        ],
                        [
                          -0.449,
                          1.417,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      27.398,
                      9.5,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 3',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.027,
                        ],
                        [
                          -1.761,
                          0.755,
                        ],
                        [
                          0.878,
                          -0.377,
                        ],
                        [
                          1.639,
                          0.047,
                        ],
                      ],
                      o: [
                        [
                          1.919,
                          0.056,
                        ],
                        [
                          0.885,
                          -0.379,
                        ],
                        [
                          -1.51,
                          0.647,
                        ],
                        [
                          -0.965,
                          -0.027,
                        ],
                      ],
                      v: [
                        [
                          -2.707,
                          1.346,
                        ],
                        [
                          2.787,
                          0.27,
                        ],
                        [
                          2.03,
                          -1.025,
                        ],
                        [
                          -2.707,
                          -0.154,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      129.262,
                      142.197,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 4',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 4,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -0.965,
                          -0.026,
                        ],
                        [
                          -1.642,
                          1.077,
                        ],
                        [
                          0.811,
                          -0.532,
                        ],
                        [
                          1.723,
                          0.046,
                        ],
                      ],
                      o: [
                        [
                          1.963,
                          0.052,
                        ],
                        [
                          0.804,
                          -0.528,
                        ],
                        [
                          -1.439,
                          0.944,
                        ],
                        [
                          -0.965,
                          -0.026,
                        ],
                      ],
                      v: [
                        [
                          -2.663,
                          1.665,
                        ],
                        [
                          2.824,
                          0.111,
                        ],
                        [
                          2.066,
                          -1.185,
                        ],
                        [
                          -2.663,
                          0.165,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      3.877,
                      49.923,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 5',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 5,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.554,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.554,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          1.004,
                        ],
                        [
                          -1.003,
                          0.001,
                        ],
                        [
                          0.001,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.596000043084,
                      0.804000016755,
                      0.289999988032,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      13.916,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 6',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 6,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.555,
                        ],
                        [
                          -0.555,
                          0,
                        ],
                        [
                          0,
                          -0.555,
                        ],
                        [
                          0.555,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.004,
                          0,
                        ],
                        [
                          0,
                          1.004,
                        ],
                        [
                          -1.004,
                          0,
                        ],
                        [
                          0,
                          -1.004,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      100.693,
                      128.689,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 7',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 7,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                      ],
                      o: [
                        [
                          0,
                          0.915,
                        ],
                        [
                          -0.916,
                          0,
                        ],
                        [
                          0,
                          -0.916,
                        ],
                        [
                          0.916,
                          0,
                        ],
                      ],
                      v: [
                        [
                          1.658,
                          0,
                        ],
                        [
                          0,
                          1.658,
                        ],
                        [
                          -1.658,
                          0,
                        ],
                        [
                          0,
                          -1.658,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0.913999968884,
                      0.57599995931,
                      0.545000023935,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      2.11,
                      135.126,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 8',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 8,
              mn: 'ADBE Vector Group',
              hd: false,
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [
                          -1.243,
                          0.643,
                        ],
                        [
                          0.612,
                          1.25,
                        ],
                        [
                          1.208,
                          -0.633,
                        ],
                        [
                          -0.202,
                          -0.134,
                        ],
                        [
                          0.142,
                          -0.23,
                        ],
                        [
                          0.283,
                          0.149,
                        ],
                        [
                          0.374,
                          0.176,
                        ],
                        [
                          -0.005,
                          0.325,
                        ],
                        [
                          -0.299,
                          0.114,
                        ],
                        [
                          -0.59,
                          1.081,
                        ],
                        [
                          -0.103,
                          0.267,
                        ],
                        [
                          -0.339,
                          0.013,
                        ],
                        [
                          -0.126,
                          -0.355,
                        ],
                        [
                          -1.441,
                          -0.565,
                        ],
                        [
                          -0.002,
                          -0.334,
                        ],
                        [
                          0.308,
                          -0.12,
                        ],
                        [
                          0.521,
                          -1.462,
                        ],
                        [
                          0.326,
                          0.005,
                        ],
                        [
                          0.124,
                          0.307,
                        ],
                        [
                          0.148,
                          0.305,
                        ],
                        [
                          -0.254,
                          0.136,
                        ],
                        [
                          -0.175,
                          -0.296,
                        ],
                        [
                          -0.096,
                          -0.173,
                        ],
                      ],
                      o: [
                        [
                          -1.226,
                          -0.643,
                        ],
                        [
                          -0.61,
                          1.238,
                        ],
                        [
                          0.247,
                          0.151,
                        ],
                        [
                          0.264,
                          0.176,
                        ],
                        [
                          -0.144,
                          0.235,
                        ],
                        [
                          -0.365,
                          -0.194,
                        ],
                        [
                          -0.289,
                          -0.136,
                        ],
                        [
                          0.005,
                          -0.326,
                        ],
                        [
                          1.15,
                          -0.437,
                        ],
                        [
                          0.137,
                          -0.251,
                        ],
                        [
                          0.118,
                          -0.309,
                        ],
                        [
                          0.319,
                          -0.011,
                        ],
                        [
                          0.52,
                          1.462,
                        ],
                        [
                          0.311,
                          0.122,
                        ],
                        [
                          0.002,
                          0.335,
                        ],
                        [
                          -1.448,
                          0.558,
                        ],
                        [
                          -0.128,
                          0.359,
                        ],
                        [
                          -0.343,
                          -0.006,
                        ],
                        [
                          -0.126,
                          -0.315,
                        ],
                        [
                          -0.154,
                          -0.314,
                        ],
                        [
                          0.25,
                          -0.133,
                        ],
                        [
                          0.081,
                          0.136,
                        ],
                        [
                          0.606,
                          -1.222,
                        ],
                      ],
                      v: [
                        [
                          2.73,
                          0.007,
                        ],
                        [
                          0.001,
                          -2.784,
                        ],
                        [
                          -2.713,
                          0.001,
                        ],
                        [
                          -2.053,
                          0.406,
                        ],
                        [
                          -1.855,
                          1.09,
                        ],
                        [
                          -2.553,
                          1.221,
                        ],
                        [
                          -3.66,
                          0.658,
                        ],
                        [
                          -4.116,
                          -0.006,
                        ],
                        [
                          -3.638,
                          -0.653,
                        ],
                        [
                          -1.016,
                          -2.921,
                        ],
                        [
                          -0.671,
                          -3.709,
                        ],
                        [
                          -0.012,
                          -4.221,
                        ],
                        [
                          0.671,
                          -3.701,
                        ],
                        [
                          3.616,
                          -0.663,
                        ],
                        [
                          4.119,
                          0.003,
                        ],
                        [
                          3.622,
                          0.674,
                        ],
                        [
                          0.673,
                          3.706,
                        ],
                        [
                          -0.008,
                          4.227,
                        ],
                        [
                          -0.671,
                          3.723,
                        ],
                        [
                          -1.09,
                          2.795,
                        ],
                        [
                          -0.938,
                          2.073,
                        ],
                        [
                          -0.248,
                          2.334,
                        ],
                        [
                          0.003,
                          2.783,
                        ],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: 'Trazado 1',
                  mn: 'ADBE Vector Shape - Group',
                  hd: false,
                },
                {
                  ty: 'fl',
                  c: {
                    a: 0,
                    k: [
                      0,
                      0.769000004787,
                      0.769000004787,
                      1,
                    ],
                    ix: 4,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 5,
                  },
                  r: 1,
                  bm: 0,
                  nm: 'Relleno 1',
                  mn: 'ADBE Vector Graphic - Fill',
                  hd: false,
                },
                {
                  ty: 'tr',
                  p: {
                    a: 0,
                    k: [
                      136.334,
                      4.482,
                    ],
                    ix: 2,
                  },
                  a: {
                    a: 0,
                    k: [
                      0,
                      0,
                    ],
                    ix: 1,
                  },
                  s: {
                    a: 0,
                    k: [
                      100,
                      100,
                    ],
                    ix: 3,
                  },
                  r: {
                    a: 0,
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    a: 0,
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    a: 0,
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    a: 0,
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transformar',
                },
              ],
              nm: 'Grupo 9',
              np: 2,
              cix: 2,
              bm: 0,
              ix: 9,
              mn: 'ADBE Vector Group',
              hd: false,
            },
          ],
          ip: 0,
          op: 750,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Capa 3 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 23,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.833,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.167,
                ],
                y: [
                  0,
                ],
              },
              t: 32,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 90,
              s: [
                100,
              ],
            },
            {
              t: 105,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.05,
                      -0.208,
                    ],
                    [
                      -0.217,
                      -0.308,
                    ],
                    [
                      -0.16,
                      -0.415,
                    ],
                    [
                      -0.023,
                      -0.454,
                    ],
                    [
                      -0.114,
                      -0.26,
                    ],
                    [
                      -0.467,
                      -1.015,
                    ],
                    [
                      0.088,
                      0.193,
                    ],
                    [
                      0.422,
                      1,
                    ],
                    [
                      -0.07,
                      0.512,
                    ],
                    [
                      0.146,
                      0.321,
                    ],
                    [
                      0.211,
                      0.88,
                    ],
                  ],
                  o: [
                    [
                      0.087,
                      0.365,
                    ],
                    [
                      0.259,
                      0.367,
                    ],
                    [
                      0.18,
                      0.467,
                    ],
                    [
                      0.014,
                      0.289,
                    ],
                    [
                      0.451,
                      1.022,
                    ],
                    [
                      0.088,
                      0.194,
                    ],
                    [
                      -0.453,
                      -0.987,
                    ],
                    [
                      -0.197,
                      -0.465,
                    ],
                    [
                      0.044,
                      -0.321,
                    ],
                    [
                      -0.353,
                      -0.774,
                    ],
                    [
                      -0.05,
                      -0.208,
                    ],
                  ],
                  v: [
                    [
                      -1.556,
                      -3.581,
                    ],
                    [
                      -1.109,
                      -2.591,
                    ],
                    [
                      -0.241,
                      -1.492,
                    ],
                    [
                      -0.309,
                      -0.237,
                    ],
                    [
                      -0.032,
                      0.578,
                    ],
                    [
                      1.232,
                      3.683,
                    ],
                    [
                      1.518,
                      3.516,
                    ],
                    [
                      0.293,
                      0.497,
                    ],
                    [
                      0.139,
                      -0.775,
                    ],
                    [
                      0.084,
                      -1.606,
                    ],
                    [
                      -1.236,
                      -3.669,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.609,
                  57.062,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.036,
                      0.209,
                    ],
                    [
                      0.394,
                      -0.399,
                    ],
                    [
                      -0.447,
                      -1.113,
                    ],
                    [
                      0.079,
                      0.198,
                    ],
                    [
                      -0.42,
                      0.647,
                    ],
                    [
                      -0.26,
                      0.261,
                    ],
                    [
                      -0.129,
                      0.117,
                    ],
                    [
                      -0.132,
                      -0.769,
                    ],
                  ],
                  o: [
                    [
                      -0.224,
                      -1.309,
                    ],
                    [
                      -0.765,
                      0.776,
                    ],
                    [
                      0.079,
                      0.195,
                    ],
                    [
                      -0.312,
                      -0.776,
                    ],
                    [
                      0.2,
                      -0.31,
                    ],
                    [
                      0.122,
                      -0.123,
                    ],
                    [
                      0.181,
                      -0.163,
                    ],
                    [
                      0.036,
                      0.21,
                    ],
                  ],
                  v: [
                    [
                      1.85,
                      -1.253,
                    ],
                    [
                      -0.247,
                      -0.84,
                    ],
                    [
                      -1.439,
                      2.367,
                    ],
                    [
                      -1.118,
                      2.279,
                    ],
                    [
                      -0.609,
                      0.204,
                    ],
                    [
                      0.053,
                      -0.665,
                    ],
                    [
                      0.439,
                      -1.018,
                    ],
                    [
                      1.529,
                      -1.165,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.585,
                  51.429,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.074,
                      -0.201,
                    ],
                    [
                      -0.959,
                      0.088,
                    ],
                    [
                      0.091,
                      0.973,
                    ],
                    [
                      -0.02,
                      -0.213,
                    ],
                    [
                      0.709,
                      -0.015,
                    ],
                    [
                      0.281,
                      0.76,
                    ],
                  ],
                  o: [
                    [
                      0.355,
                      0.96,
                    ],
                    [
                      0.86,
                      -0.078,
                    ],
                    [
                      -0.02,
                      -0.211,
                    ],
                    [
                      0.082,
                      0.873,
                    ],
                    [
                      -0.744,
                      0.015,
                    ],
                    [
                      -0.074,
                      -0.199,
                    ],
                  ],
                  v: [
                    [
                      -2.434,
                      -0.266,
                    ],
                    [
                      0.196,
                      1.088,
                    ],
                    [
                      2.417,
                      -0.963,
                    ],
                    [
                      2.085,
                      -0.963,
                    ],
                    [
                      0.013,
                      0.763,
                    ],
                    [
                      -2.113,
                      -0.354,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.011,
                  51.131,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.029,
                      0.21,
                    ],
                    [
                      0.439,
                      -0.339,
                    ],
                    [
                      -0.404,
                      -0.689,
                    ],
                    [
                      0.108,
                      0.185,
                    ],
                    [
                      -0.013,
                      0.398,
                    ],
                    [
                      -0.124,
                      0.19,
                    ],
                    [
                      -0.132,
                      0.063,
                    ],
                    [
                      -0.145,
                      -0.246,
                    ],
                  ],
                  o: [
                    [
                      0.103,
                      -0.735,
                    ],
                    [
                      -0.712,
                      0.549,
                    ],
                    [
                      0.108,
                      0.185,
                    ],
                    [
                      -0.2,
                      -0.34,
                    ],
                    [
                      0.008,
                      -0.232,
                    ],
                    [
                      0.063,
                      -0.128,
                    ],
                    [
                      0.217,
                      -0.17,
                    ],
                    [
                      -0.029,
                      0.209,
                    ],
                  ],
                  v: [
                    [
                      0.891,
                      -0.694,
                    ],
                    [
                      -0.282,
                      -1.08,
                    ],
                    [
                      -0.413,
                      1.244,
                    ],
                    [
                      -0.127,
                      1.077,
                    ],
                    [
                      -0.426,
                      -0.02,
                    ],
                    [
                      -0.265,
                      -0.609,
                    ],
                    [
                      0.027,
                      -0.897,
                    ],
                    [
                      0.57,
                      -0.782,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.148,
                  49.956,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.088,
                      0.012,
                    ],
                    [
                      -0.147,
                      0.096,
                    ],
                    [
                      -0.042,
                      0.175,
                    ],
                    [
                      0.051,
                      -0.207,
                    ],
                    [
                      0.114,
                      -0.056,
                    ],
                    [
                      0.12,
                      -0.016,
                    ],
                    [
                      -0.021,
                      -0.078,
                    ],
                  ],
                  o: [
                    [
                      0.171,
                      -0.023,
                    ],
                    [
                      0.152,
                      -0.098,
                    ],
                    [
                      0.05,
                      -0.208,
                    ],
                    [
                      -0.029,
                      0.119,
                    ],
                    [
                      -0.11,
                      0.054,
                    ],
                    [
                      -0.09,
                      0.012,
                    ],
                    [
                      0.025,
                      0.096,
                    ],
                  ],
                  v: [
                    [
                      -0.297,
                      0.417,
                    ],
                    [
                      0.204,
                      0.254,
                    ],
                    [
                      0.472,
                      -0.133,
                    ],
                    [
                      0.152,
                      -0.221,
                    ],
                    [
                      -0.024,
                      0.004,
                    ],
                    [
                      -0.385,
                      0.096,
                    ],
                    [
                      -0.501,
                      0.301,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.583,
                  49.333,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.213,
                      0.014,
                    ],
                    [
                      0.401,
                      0.874,
                    ],
                    [
                      0.758,
                      -0.437,
                    ],
                    [
                      0.104,
                      -1.122,
                    ],
                    [
                      -1.032,
                      0.067,
                    ],
                    [
                      0.213,
                      -0.013,
                    ],
                    [
                      -0.857,
                      0.871,
                    ],
                    [
                      -0.55,
                      0.097,
                    ],
                    [
                      -0.317,
                      -0.246,
                    ],
                    [
                      0.754,
                      -0.049,
                    ],
                  ],
                  o: [
                    [
                      0.783,
                      -0.052,
                    ],
                    [
                      -0.439,
                      -0.958,
                    ],
                    [
                      -0.972,
                      0.561,
                    ],
                    [
                      -0.096,
                      1.031,
                    ],
                    [
                      0.212,
                      -0.014,
                    ],
                    [
                      -1.943,
                      0.127,
                    ],
                    [
                      0.376,
                      -0.382,
                    ],
                    [
                      0.376,
                      -0.067,
                    ],
                    [
                      0.672,
                      0.52,
                    ],
                    [
                      -0.212,
                      0.014,
                    ],
                  ],
                  v: [
                    [
                      0.836,
                      -0.079,
                    ],
                    [
                      2.053,
                      -1.574,
                    ],
                    [
                      -0.427,
                      -1.993,
                    ],
                    [
                      -2.212,
                      0.659,
                    ],
                    [
                      -0.511,
                      2.465,
                    ],
                    [
                      -0.511,
                      2.133,
                    ],
                    [
                      -1.073,
                      -1.029,
                    ],
                    [
                      0.314,
                      -1.947,
                    ],
                    [
                      1.442,
                      -1.77,
                    ],
                    [
                      0.836,
                      -0.41,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.792,
                  47.286,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.478,
                      1.254,
                    ],
                    [
                      1.696,
                      -0.646,
                    ],
                    [
                      0.143,
                      -1.002,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.397,
                      0.041,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.003,
                      0.341,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.359,
                      0.518,
                    ],
                  ],
                  o: [
                    [
                      -0.478,
                      -1.254,
                    ],
                    [
                      -1.284,
                      0.49,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.258,
                      -0.303,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.207,
                      -0.272,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.749,
                      0.75,
                    ],
                    [
                      1.695,
                      -0.646,
                    ],
                  ],
                  v: [
                    [
                      6.712,
                      -4.573,
                    ],
                    [
                      2.777,
                      -5.675,
                    ],
                    [
                      0.473,
                      -3.187,
                    ],
                    [
                      0.473,
                      -3.184,
                    ],
                    [
                      -0.61,
                      -3.031,
                    ],
                    [
                      -2.993,
                      -5.205,
                    ],
                    [
                      -4.013,
                      -5.741,
                    ],
                    [
                      -7.189,
                      -6.223,
                    ],
                    [
                      -2.137,
                      6.32,
                    ],
                    [
                      -0.157,
                      3.348,
                    ],
                    [
                      0.158,
                      2.402,
                    ],
                    [
                      0.195,
                      -0.951,
                    ],
                    [
                      1.001,
                      -1.578,
                    ],
                    [
                      1.006,
                      -1.573,
                    ],
                    [
                      4.508,
                      -1.133,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  89.033,
                  74.437,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.598,
                      7.098,
                    ],
                    [
                      -2.77,
                      -7.033,
                    ],
                    [
                      -2.596,
                      -7.098,
                    ],
                    [
                      2.77,
                      7.033,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  83.627,
                  48.354,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.449,
                      6.708,
                    ],
                    [
                      -2.621,
                      -6.643,
                    ],
                    [
                      -2.449,
                      -6.708,
                    ],
                    [
                      2.621,
                      6.643,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  86.841,
                  45.71,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      3.318,
                      8.995,
                    ],
                    [
                      -3.49,
                      -8.93,
                    ],
                    [
                      -3.318,
                      -8.995,
                    ],
                    [
                      3.49,
                      8.931,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.446,
                  54.807,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.309,
                      6.339,
                    ],
                    [
                      -2.481,
                      -6.273,
                    ],
                    [
                      -2.309,
                      -6.339,
                    ],
                    [
                      2.481,
                      6.274,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  81.843,
                  48.354,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.736,
                      7.462,
                    ],
                    [
                      -2.908,
                      -7.396,
                    ],
                    [
                      -2.736,
                      -7.462,
                    ],
                    [
                      2.908,
                      7.398,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  85.43,
                  47.694,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.282,
                      6.786,
                    ],
                    [
                      -2.797,
                      -6.59,
                    ],
                    [
                      -2.282,
                      -6.786,
                    ],
                    [
                      2.797,
                      6.59,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  89.565,
                  43.94,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -2.209,
                      -1.3,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.421,
                      1.111,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.742,
                      0.477,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.421,
                      -1.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.708,
                      -1.304,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1,
                      0.642,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.312,
                      -0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1,
                      -0.642,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.708,
                      1.303,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      17.462,
                      18.695,
                    ],
                    [
                      -0.459,
                      30.201,
                    ],
                    [
                      -3.218,
                      29.29,
                    ],
                    [
                      -4.79,
                      25.129,
                    ],
                    [
                      -19.719,
                      -14.192,
                    ],
                    [
                      -18.982,
                      -16.424,
                    ],
                    [
                      2.454,
                      -30.201,
                    ],
                    [
                      5.213,
                      -29.288,
                    ],
                    [
                      6.788,
                      -25.122,
                    ],
                    [
                      20.031,
                      9.758,
                    ],
                    [
                      18.278,
                      12.79,
                    ],
                    [
                      16.604,
                      15.928,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.987999949736,
                  0.910000011968,
                  0.910000011968,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  86.545,
                  59.861,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 127,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: 'Capa 2 contornos',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.634,
                      -0.542,
                    ],
                    [
                      -9.608,
                      -0.189,
                    ],
                    [
                      -1.091,
                      -0.398,
                    ],
                    [
                      -1.511,
                      -1.296,
                    ],
                    [
                      1.862,
                      0.646,
                    ],
                    [
                      2.453,
                      -0.137,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.758,
                      0.035,
                    ],
                    [
                      1.714,
                      0.626,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.678,
                      -0.582,
                    ],
                    [
                      -4.412,
                      0.246,
                    ],
                  ],
                  v: [
                    [
                      -9.961,
                      -0.777,
                    ],
                    [
                      0.852,
                      -1.986,
                    ],
                    [
                      5.04,
                      -1.433,
                    ],
                    [
                      9.961,
                      2.175,
                    ],
                    [
                      4.807,
                      -1.203,
                    ],
                    [
                      -2.879,
                      -1.672,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  121.205,
                  65.081,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.764,
                      -0.66,
                    ],
                    [
                      -0.323,
                      1.563,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.691,
                      -1.725,
                    ],
                    [
                      -0.692,
                      1.725,
                    ],
                    [
                      0.649,
                      -0.686,
                    ],
                    [
                      0.512,
                      -0.894,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  139.903,
                  91.915,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.189,
                      -0.054,
                    ],
                    [
                      -0.552,
                      1.074,
                    ],
                    [
                      1.609,
                      -0.847,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.727,
                      1.366,
                    ],
                    [
                      1.728,
                      -1.369,
                    ],
                    [
                      -1.062,
                      1.369,
                    ],
                    [
                      -1.253,
                      1.198,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  125.854,
                  112.226,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      5.1,
                      -1.513,
                    ],
                    [
                      -3.555,
                      8.655,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -3.181,
                      4.45,
                    ],
                    [
                      3.182,
                      -4.45,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  136.34,
                  103.119,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -1.344,
                      4.502,
                    ],
                    [
                      -3.493,
                      -1.754,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.612,
                      -2.973,
                    ],
                    [
                      1.747,
                      2.974,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  113.365,
                  106.836,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.783,
                      -0.207,
                    ],
                    [
                      -1.092,
                      0.055,
                    ],
                    [
                      2.066,
                      0.838,
                    ],
                    [
                      0.923,
                      0.7,
                    ],
                  ],
                  o: [
                    [
                      0.765,
                      0.545,
                    ],
                    [
                      2.268,
                      0.602,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.913,
                      -0.371,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -3.82,
                      -0.445,
                    ],
                    [
                      -1.432,
                      0.79,
                    ],
                    [
                      4.173,
                      1.173,
                    ],
                    [
                      -1.257,
                      0.409,
                    ],
                    [
                      -4.174,
                      -1.392,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  130.847,
                  91.906,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.717,
                      0.202,
                    ],
                    [
                      1.056,
                      -1.209,
                    ],
                    [
                      1.874,
                      -1.984,
                    ],
                    [
                      2.314,
                      1.002,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.406,
                      1.772,
                    ],
                    [
                      -0.671,
                      0.428,
                    ],
                    [
                      -2.628,
                      -0.123,
                    ],
                  ],
                  o: [
                    [
                      -0.672,
                      -0.672,
                    ],
                    [
                      -0.857,
                      0.367,
                    ],
                    [
                      -0.924,
                      -0.108,
                    ],
                    [
                      -0.921,
                      1.057,
                    ],
                    [
                      -2.67,
                      2.829,
                    ],
                    [
                      -3.153,
                      -1.366,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.405,
                      -1.772,
                    ],
                    [
                      0.673,
                      -0.428,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      10.766,
                      3.513,
                    ],
                    [
                      8.624,
                      2.535,
                    ],
                    [
                      5.704,
                      1.614,
                    ],
                    [
                      2.667,
                      1.451,
                    ],
                    [
                      -0.18,
                      5.162,
                    ],
                    [
                      -7.613,
                      7.34,
                    ],
                    [
                      -9.167,
                      4.223,
                    ],
                    [
                      -4.756,
                      -3.392,
                    ],
                    [
                      -1.213,
                      -7.181,
                    ],
                    [
                      4.656,
                      -8.219,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  112.315,
                  71.565,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.16,
                    ],
                    [
                      1.758,
                      -1.118,
                    ],
                    [
                      -0.112,
                      -0.046,
                    ],
                    [
                      0.764,
                      2.02,
                    ],
                    [
                      -0.105,
                      -0.278,
                    ],
                    [
                      -0.765,
                      -2.021,
                    ],
                    [
                      -0.136,
                      0.086,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -1.758,
                      1.118,
                    ],
                    [
                      0.113,
                      0.046,
                    ],
                    [
                      -0.765,
                      -2.021,
                    ],
                    [
                      -0.105,
                      -0.274,
                    ],
                    [
                      0.766,
                      2.02,
                    ],
                    [
                      0.051,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.249,
                      -0.158,
                    ],
                  ],
                  v: [
                    [
                      3.651,
                      -0.497,
                    ],
                    [
                      -1.624,
                      2.857,
                    ],
                    [
                      -1.286,
                      2.995,
                    ],
                    [
                      -3.581,
                      -3.066,
                    ],
                    [
                      -4.025,
                      -2.944,
                    ],
                    [
                      -1.73,
                      3.117,
                    ],
                    [
                      -1.391,
                      3.254,
                    ],
                    [
                      3.882,
                      -0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.603999956916,
                  0.8,
                  0.325,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  111.27,
                  67.223,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.159,
                    ],
                    [
                      1.757,
                      -1.119,
                    ],
                    [
                      -0.112,
                      -0.046,
                    ],
                    [
                      0.765,
                      2.02,
                    ],
                    [
                      -0.105,
                      -0.278,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      -0.136,
                      0.086,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -1.759,
                      1.118,
                    ],
                    [
                      0.112,
                      0.045,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      -0.104,
                      -0.274,
                    ],
                    [
                      0.765,
                      2.019,
                    ],
                    [
                      0.05,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.249,
                      -0.159,
                    ],
                  ],
                  v: [
                    [
                      3.651,
                      -0.498,
                    ],
                    [
                      -1.624,
                      2.857,
                    ],
                    [
                      -1.286,
                      2.995,
                    ],
                    [
                      -3.583,
                      -3.066,
                    ],
                    [
                      -4.025,
                      -2.944,
                    ],
                    [
                      -1.73,
                      3.117,
                    ],
                    [
                      -1.391,
                      3.255,
                    ],
                    [
                      3.882,
                      -0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.603999956916,
                  0.8,
                  0.325,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  83.276,
                  94.119,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.25,
                      0.159,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.765,
                      -2.02,
                    ],
                    [
                      0.104,
                      0.277,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.135,
                      -0.086,
                    ],
                    [
                      1.757,
                      -1.119,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.765,
                      2.02,
                    ],
                    [
                      0.104,
                      0.274,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.05,
                      -0.132,
                    ],
                    [
                      -1.758,
                      1.118,
                    ],
                    [
                      -0.249,
                      0.158,
                    ],
                  ],
                  v: [
                    [
                      -3.65,
                      0.497,
                    ],
                    [
                      1.623,
                      -2.857,
                    ],
                    [
                      1.287,
                      -2.995,
                    ],
                    [
                      3.582,
                      3.066,
                    ],
                    [
                      4.026,
                      2.944,
                    ],
                    [
                      1.729,
                      -3.117,
                    ],
                    [
                      1.392,
                      -3.254,
                    ],
                    [
                      -3.881,
                      0.101,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.603999956916,
                  0.8,
                  0.325,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  90.808,
                  25.998,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.106,
                      0.276,
                    ],
                    [
                      0.189,
                      0.489,
                    ],
                    [
                      -0.107,
                      -0.277,
                    ],
                    [
                      -0.189,
                      -0.489,
                    ],
                  ],
                  o: [
                    [
                      -0.188,
                      -0.489,
                    ],
                    [
                      -0.105,
                      -0.273,
                    ],
                    [
                      0.189,
                      0.489,
                    ],
                    [
                      0.105,
                      0.273,
                    ],
                  ],
                  v: [
                    [
                      0.505,
                      0.673,
                    ],
                    [
                      -0.061,
                      -0.795,
                    ],
                    [
                      -0.504,
                      -0.673,
                    ],
                    [
                      0.062,
                      0.794,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.603999956916,
                  0.8,
                  0.325,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  109.642,
                  67.99,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.25,
                      -0.161,
                    ],
                    [
                      2.239,
                      -1.444,
                    ],
                    [
                      -0.037,
                      -0.097,
                    ],
                    [
                      -0.956,
                      -2.509,
                    ],
                    [
                      0.105,
                      0.277,
                    ],
                    [
                      0.83,
                      2.179,
                    ],
                    [
                      0.183,
                      0.178,
                    ],
                    [
                      -0.269,
                      0.019,
                    ],
                    [
                      -0.097,
                      0.063,
                    ],
                    [
                      -1.141,
                      0.736,
                    ],
                    [
                      -0.917,
                      0.591,
                    ],
                  ],
                  o: [
                    [
                      -2.239,
                      1.445,
                    ],
                    [
                      -0.079,
                      0.051,
                    ],
                    [
                      0.956,
                      2.509,
                    ],
                    [
                      0.104,
                      0.274,
                    ],
                    [
                      -0.83,
                      -2.179,
                    ],
                    [
                      -0.089,
                      -0.233,
                    ],
                    [
                      0.135,
                      0.13,
                    ],
                    [
                      0.115,
                      -0.008,
                    ],
                    [
                      1.142,
                      -0.736,
                    ],
                    [
                      0.917,
                      -0.592,
                    ],
                    [
                      0.247,
                      -0.16,
                    ],
                  ],
                  v: [
                    [
                      3.191,
                      -6.117,
                    ],
                    [
                      -3.527,
                      -1.783,
                    ],
                    [
                      -3.633,
                      -1.523,
                    ],
                    [
                      -0.765,
                      6.003,
                    ],
                    [
                      -0.322,
                      5.882,
                    ],
                    [
                      -2.813,
                      -0.656,
                    ],
                    [
                      -3.178,
                      -1.613,
                    ],
                    [
                      -3.185,
                      -1.457,
                    ],
                    [
                      -2.754,
                      -1.736,
                    ],
                    [
                      0.671,
                      -3.945,
                    ],
                    [
                      3.423,
                      -5.72,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.603999956916,
                  0.8,
                  0.325,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.817,
                  43.17,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.131,
                      0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.216,
                      0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.131,
                      -0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.216,
                      -0.132,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.13,
                      -0.216,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.216,
                      -0.131,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.131,
                      0.215,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.215,
                      0.131,
                    ],
                  ],
                  v: [
                    [
                      -2.908,
                      1.832,
                    ],
                    [
                      -2.967,
                      1.736,
                    ],
                    [
                      -2.812,
                      1.108,
                    ],
                    [
                      2.28,
                      -1.985,
                    ],
                    [
                      2.908,
                      -1.832,
                    ],
                    [
                      2.965,
                      -1.736,
                    ],
                    [
                      2.812,
                      -1.108,
                    ],
                    [
                      -2.281,
                      1.985,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.556999954523,
                  0.556999954523,
                  0.556999954523,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  71.166,
                  20.062,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.724,
                      0,
                    ],
                    [
                      0.423,
                      0.144,
                    ],
                    [
                      0.434,
                      1.108,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.548,
                      0.933,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.126,
                      -0.382,
                    ],
                    [
                      -0.433,
                      -1.108,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.075,
                      0.366,
                    ],
                    [
                      0.973,
                      -0.586,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.904,
                      -2.673,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.075,
                      -0.365,
                    ],
                    [
                      -0.972,
                      0.586,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.151,
                    ],
                    [
                      -2.854,
                      0,
                    ],
                    [
                      -0.843,
                      -1.838,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.685,
                      1.748,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.685,
                      -1.016,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.99,
                      0,
                    ],
                    [
                      0,
                      -2.753,
                    ],
                    [
                      -0.715,
                      -0.893,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.437,
                      0,
                    ],
                    [
                      -1.126,
                      -0.383,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.938,
                      -2.772,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.019,
                      -0.615,
                    ],
                    [
                      1.126,
                      0.383,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.415,
                      -1.058,
                    ],
                    [
                      -1.074,
                      -0.365,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.497,
                      0.903,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.413,
                      1.058,
                    ],
                    [
                      1.074,
                      0.366,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.698,
                      -0.91,
                    ],
                    [
                      0,
                      -2.855,
                    ],
                    [
                      2.028,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.608,
                      -0.969,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.717,
                      1.832,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.793,
                      -1.827,
                    ],
                    [
                      -2.753,
                      0,
                    ],
                    [
                      0,
                      1.144,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.636,
                      0.384,
                    ],
                  ],
                  v: [
                    [
                      -1.739,
                      53.201,
                    ],
                    [
                      -3.037,
                      52.986,
                    ],
                    [
                      -5.491,
                      50.641,
                    ],
                    [
                      -35.496,
                      -26.385,
                    ],
                    [
                      -33.033,
                      -32.76,
                    ],
                    [
                      -0.461,
                      -52.454,
                    ],
                    [
                      2.914,
                      -52.818,
                    ],
                    [
                      5.368,
                      -50.473,
                    ],
                    [
                      27.616,
                      6.637,
                    ],
                    [
                      27.446,
                      6.704,
                    ],
                    [
                      5.198,
                      -50.406,
                    ],
                    [
                      2.855,
                      -52.645,
                    ],
                    [
                      -0.366,
                      -52.297,
                    ],
                    [
                      -32.938,
                      -32.604,
                    ],
                    [
                      -35.323,
                      -26.448,
                    ],
                    [
                      -5.319,
                      50.574,
                    ],
                    [
                      -2.977,
                      52.811,
                    ],
                    [
                      0.243,
                      52.464,
                    ],
                    [
                      11.925,
                      45.436,
                    ],
                    [
                      10.859,
                      42.289,
                    ],
                    [
                      16.035,
                      37.111,
                    ],
                    [
                      20.742,
                      40.133,
                    ],
                    [
                      33.951,
                      32.186,
                    ],
                    [
                      35.545,
                      27.495,
                    ],
                    [
                      32.014,
                      18.43,
                    ],
                    [
                      32.185,
                      18.363,
                    ],
                    [
                      35.717,
                      27.428,
                    ],
                    [
                      34.046,
                      32.344,
                    ],
                    [
                      20.658,
                      40.396,
                    ],
                    [
                      20.616,
                      40.301,
                    ],
                    [
                      16.035,
                      37.296,
                    ],
                    [
                      11.042,
                      42.289,
                    ],
                    [
                      12.134,
                      45.404,
                    ],
                    [
                      12.199,
                      45.485,
                    ],
                    [
                      12.11,
                      45.54,
                    ],
                    [
                      0.338,
                      52.621,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.556999954523,
                  0.556999954523,
                  0.556999954523,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.119,
                  59.197,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.088,
                      -1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.876,
                      -2.59,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.088,
                      1.258,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      1.2,
                    ],
                    [
                      -2.809,
                      0,
                    ],
                    [
                      -0.783,
                      -1.801,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.698,
                      1.785,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.889,
                      -2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.641,
                      0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.889,
                      2.272,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.695,
                      -0.87,
                    ],
                    [
                      0,
                      -2.809,
                    ],
                    [
                      2.089,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.641,
                      -0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      27.51,
                      6.587,
                    ],
                    [
                      5.261,
                      -50.523,
                    ],
                    [
                      -0.434,
                      -52.459,
                    ],
                    [
                      -33.008,
                      -32.766,
                    ],
                    [
                      -35.432,
                      -26.502,
                    ],
                    [
                      -5.427,
                      50.523,
                    ],
                    [
                      0.269,
                      52.46,
                    ],
                    [
                      12.04,
                      45.378,
                    ],
                    [
                      10.929,
                      42.206,
                    ],
                    [
                      16.014,
                      37.121,
                    ],
                    [
                      20.68,
                      40.18,
                    ],
                    [
                      33.977,
                      32.181,
                    ],
                    [
                      35.61,
                      27.378,
                    ],
                    [
                      32.078,
                      18.313,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.14,
                  59.281,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 15',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 15,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.108,
                      0,
                    ],
                    [
                      0,
                      -2.108,
                    ],
                    [
                      -2.108,
                      0,
                    ],
                    [
                      0,
                      2.109,
                    ],
                  ],
                  o: [
                    [
                      -2.108,
                      0,
                    ],
                    [
                      0,
                      2.109,
                    ],
                    [
                      2.108,
                      0,
                    ],
                    [
                      0,
                      -2.108,
                    ],
                  ],
                  v: [
                    [
                      -0.001,
                      -3.824,
                    ],
                    [
                      -3.824,
                      -0.001,
                    ],
                    [
                      -0.001,
                      3.824,
                    ],
                    [
                      3.824,
                      -0.001,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      2.21,
                      0,
                    ],
                    [
                      0,
                      2.21,
                    ],
                    [
                      -2.209,
                      0,
                    ],
                    [
                      0,
                      -2.21,
                    ],
                  ],
                  o: [
                    [
                      -2.209,
                      0,
                    ],
                    [
                      0,
                      -2.21,
                    ],
                    [
                      2.21,
                      0,
                    ],
                    [
                      0,
                      2.21,
                    ],
                  ],
                  v: [
                    [
                      -0.001,
                      4.008,
                    ],
                    [
                      -4.008,
                      -0.001,
                    ],
                    [
                      -0.001,
                      -4.008,
                    ],
                    [
                      4.008,
                      -0.001,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'mm',
              mm: 1,
              nm: 'Combinar trazados 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.556999954523,
                  0.556999954523,
                  0.556999954523,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  103.155,
                  101.487,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 16',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 16,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.639,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.195,
                    ],
                    [
                      -1.941,
                      0.72,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  48.398,
                  37.252,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 17',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 17,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.167,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.638,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.638,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.195,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.941,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  47.821,
                  35.833,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 18',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 18,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      1.201,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.671,
                  114.683,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 19',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 19,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.167,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      1.201,
                      -0.638,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.638,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      -0.314,
                      0.166,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.195,
                    ],
                    [
                      1.941,
                      -0.72,
                    ],
                    [
                      1.663,
                      -1.196,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  78.094,
                  113.264,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 20',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 20,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.201,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.202,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.314,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.313,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.664,
                      1.196,
                    ],
                    [
                      1.941,
                      -0.719,
                    ],
                    [
                      1.663,
                      -1.195,
                    ],
                    [
                      -1.942,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  75.801,
                  107.558,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 21',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 21,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.313,
                      0.166,
                    ],
                    [
                      -1.202,
                      0.639,
                    ],
                    [
                      0.314,
                      -0.167,
                    ],
                    [
                      1.201,
                      -0.637,
                    ],
                  ],
                  o: [
                    [
                      1.202,
                      -0.639,
                    ],
                    [
                      0.313,
                      -0.166,
                    ],
                    [
                      -1.202,
                      0.638,
                    ],
                    [
                      -0.314,
                      0.167,
                    ],
                  ],
                  v: [
                    [
                      -1.663,
                      1.196,
                    ],
                    [
                      1.942,
                      -0.719,
                    ],
                    [
                      1.664,
                      -1.195,
                    ],
                    [
                      -1.941,
                      0.719,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.717999985639,
                  0.325,
                  0.035000000748,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  74.845,
                  105.047,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 22',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 22,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.641,
                      -0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.889,
                      2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.642,
                      0.99,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.888,
                      -2.271,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.698,
                      1.785,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.088,
                      1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.876,
                      -2.59,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      2.089,
                      -1.259,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      34.056,
                      16.546,
                    ],
                    [
                      39.506,
                      30.467,
                    ],
                    [
                      37.874,
                      35.27,
                    ],
                    [
                      -0.13,
                      57.977,
                    ],
                    [
                      -5.826,
                      56.042,
                    ],
                    [
                      -39.327,
                      -29.59,
                    ],
                    [
                      -36.902,
                      -35.854,
                    ],
                    [
                      -0.036,
                      -57.977,
                    ],
                    [
                      5.661,
                      -56.041,
                    ],
                    [
                      29.503,
                      4.898,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.136999990426,
                  0.136999990426,
                  0.136999990426,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  87.411,
                  60.672,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 23',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 23,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.209,
                      0,
                    ],
                    [
                      0.691,
                      0.236,
                    ],
                    [
                      0.702,
                      1.795,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.778,
                      1.675,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.116,
                      -2.854,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.712,
                      -0.582,
                    ],
                    [
                      -1.614,
                      0.974,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      -0.717,
                      0,
                    ],
                    [
                      -1.815,
                      -0.617,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.182,
                      -3.02,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.624,
                      1.582,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.663,
                      1.695,
                    ],
                    [
                      1.756,
                      0.596,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.072,
                      0.647,
                    ],
                  ],
                  v: [
                    [
                      6.273,
                      55.553,
                    ],
                    [
                      4.147,
                      55.202,
                    ],
                    [
                      0.185,
                      51.406,
                    ],
                    [
                      -31.797,
                      -30.341,
                    ],
                    [
                      -29.043,
                      -38.445,
                    ],
                    [
                      -0.545,
                      -55.553,
                    ],
                    [
                      -0.356,
                      -55.238,
                    ],
                    [
                      -28.853,
                      -38.13,
                    ],
                    [
                      -31.455,
                      -30.475,
                    ],
                    [
                      0.527,
                      51.271,
                    ],
                    [
                      4.265,
                      54.855,
                    ],
                    [
                      9.57,
                      54.262,
                    ],
                    [
                      32.791,
                      40.398,
                    ],
                    [
                      32.979,
                      40.712,
                    ],
                    [
                      9.759,
                      54.576,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.922000002394,
                  0.458999992819,
                  0.030999998953,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.65,
                  64.797,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 24',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 24,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.457,
                      3.726,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.693,
                      1.623,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -3.425,
                      2.066,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.146,
                      -2.928,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      32.829,
                      40.011,
                    ],
                    [
                      9.607,
                      53.874,
                    ],
                    [
                      0.299,
                      50.793,
                    ],
                    [
                      -31.683,
                      -30.952,
                    ],
                    [
                      -29.005,
                      -38.831,
                    ],
                    [
                      -0.508,
                      -55.94,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.922000002394,
                  0.458999992819,
                  0.030999998953,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  76.707,
                  65.342,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 25',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 25,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -5.159,
                      -1.717,
                    ],
                    [
                      -2.346,
                      1.028,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -6.68,
                      14.168,
                    ],
                    [
                      1.469,
                      0.796,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.081,
                      0.584,
                    ],
                    [
                      -0.007,
                      0.043,
                    ],
                    [
                      2.478,
                      5.167,
                    ],
                    [
                      2.628,
                      2.2,
                    ],
                    [
                      1.834,
                      0.197,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1.29,
                      0.852,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.122,
                      -1.072,
                    ],
                    [
                      0.498,
                      -0.31,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      6.237,
                      2.077,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.47,
                      -0.795,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.005,
                      -0.04,
                    ],
                    [
                      0.17,
                      -1.069,
                    ],
                    [
                      -0.853,
                      -1.777,
                    ],
                    [
                      -2.627,
                      -2.2,
                    ],
                    [
                      -0.431,
                      -0.046,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.364,
                      -0.901,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.08,
                      0.71,
                    ],
                    [
                      -0.496,
                      0.311,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -29.209,
                      16.982,
                    ],
                    [
                      -18.522,
                      22.508,
                    ],
                    [
                      -3.854,
                      24.399,
                    ],
                    [
                      9.829,
                      32.574,
                    ],
                    [
                      29.21,
                      16.025,
                    ],
                    [
                      17.477,
                      7.782,
                    ],
                    [
                      11.982,
                      2.028,
                    ],
                    [
                      12.282,
                      0.548,
                    ],
                    [
                      12.303,
                      0.423,
                    ],
                    [
                      9.63,
                      -9.608,
                    ],
                    [
                      2.487,
                      -21.973,
                    ],
                    [
                      -3.5,
                      -25.715,
                    ],
                    [
                      -6.391,
                      -25.928,
                    ],
                    [
                      -11.097,
                      -28.865,
                    ],
                    [
                      -15.981,
                      -32.574,
                    ],
                    [
                      -4.138,
                      -2.245,
                    ],
                    [
                      -3.992,
                      -0.627,
                    ],
                    [
                      -5.204,
                      1.723,
                    ],
                    [
                      -6.107,
                      2.377,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  128.449,
                  89.023,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 26',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 26,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.631,
                      -3.944,
                    ],
                    [
                      -3.658,
                      0.618,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.631,
                      3.942,
                    ],
                    [
                      3.657,
                      -0.618,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      8.654,
                      -4.688,
                    ],
                    [
                      -2.96,
                      -3.858,
                    ],
                    [
                      -8.956,
                      0.538,
                    ],
                    [
                      0.359,
                      4.07,
                    ],
                    [
                      9.587,
                      3.876,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  60.786,
                  57.576,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 27',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 27,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.16,
                      -4.239,
                    ],
                    [
                      -2.267,
                      0.321,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.161,
                      4.238,
                    ],
                    [
                      2.267,
                      -0.321,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      7.161,
                      -4.53,
                    ],
                    [
                      -3.586,
                      -4.061,
                    ],
                    [
                      -9.525,
                      0.131,
                    ],
                    [
                      -1.116,
                      4.209,
                    ],
                    [
                      9.686,
                      3.566,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  64.799,
                  70.817,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 28',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 28,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.363,
                      -3.152,
                    ],
                    [
                      -3.893,
                      -0.276,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.364,
                      3.151,
                    ],
                    [
                      3.894,
                      0.277,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      7.956,
                      -3.076,
                    ],
                    [
                      -3.462,
                      -3.076,
                    ],
                    [
                      -9.587,
                      -0.623,
                    ],
                    [
                      -2.072,
                      3.498,
                    ],
                    [
                      9.951,
                      3.498,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  71.67,
                  86.238,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 29',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 29,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 127,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 5,
      ty: 4,
      nm: 'Capa 4 contornos',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 90,
              s: [
                100,
              ],
            },
            {
              t: 105,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [
                93,
                103.5,
                9,
              ],
              to: [
                0,
                -4.833,
                -1.5,
              ],
              ti: [
                0,
                4.833,
                1.5,
              ],
            },
            {
              t: 14,
              s: [
                93,
                74.5,
                0,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.659,
                      0,
                    ],
                    [
                      0.48,
                      0.27,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.773,
                      -0.288,
                    ],
                    [
                      0.857,
                      0.099,
                    ],
                    [
                      -0.857,
                      0.018,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  6.389,
                  116.743,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.214,
                      0.122,
                    ],
                    [
                      0.485,
                      0.352,
                    ],
                    [
                      -0.946,
                      0.047,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.785,
                      -0.212,
                    ],
                    [
                      -0.785,
                      -0.141,
                    ],
                    [
                      0.374,
                      0.148,
                    ],
                    [
                      0.385,
                      -0.04,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  38.684,
                  123.453,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.111,
                      1.318,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.914,
                      -0.12,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -0.964,
                      -0.583,
                    ],
                    [
                      -0.727,
                      -0.736,
                    ],
                    [
                      0.964,
                      0.566,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  33.836,
                  126.985,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.177,
                      0.246,
                    ],
                    [
                      1.345,
                      0.287,
                    ],
                    [
                      -0.872,
                      0.273,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      1.017,
                      -0.483,
                    ],
                    [
                      -1.017,
                      0.141,
                    ],
                    [
                      0.579,
                      0.21,
                    ],
                    [
                      0.584,
                      0.029,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  36.803,
                  127.724,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      9.178,
                      4.292,
                    ],
                    [
                      -2.114,
                      -8.996,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -5.676,
                      -6.119,
                    ],
                    [
                      5.676,
                      6.12,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.908,
                  133.443,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      1.959,
                      1.996,
                    ],
                    [
                      -2.948,
                      0.114,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.432,
                      -0.998,
                    ],
                    [
                      2.432,
                      -0.113,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  25.06,
                  154.047,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.421,
                      2.363,
                    ],
                    [
                      -0.713,
                      -1.748,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.523,
                      -2.368,
                    ],
                    [
                      0.189,
                      2.368,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.917999985639,
                  0.677999997606,
                  0.626999978458,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.294,
                  156.246,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.289,
                      -0.364,
                    ],
                    [
                      1.624,
                      -1.652,
                    ],
                    [
                      -0.924,
                      -3.165,
                    ],
                    [
                      0.168,
                      -3.053,
                    ],
                    [
                      2.885,
                      -2.464,
                    ],
                    [
                      -0.589,
                      -3.864,
                    ],
                    [
                      9.464,
                      5.953,
                    ],
                    [
                      -0.15,
                      0,
                    ],
                    [
                      3.36,
                      8.738,
                    ],
                    [
                      -0.455,
                      3.31,
                    ],
                    [
                      -0.213,
                      2.118,
                    ],
                    [
                      -1.573,
                      2.071,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -2.016,
                      -1.755,
                    ],
                    [
                      5.449,
                      -10.189,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.008,
                      -0.435,
                    ],
                    [
                      -2.788,
                      -2.843,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.925,
                      3.164,
                    ],
                    [
                      -0.169,
                      3.053,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.177,
                      -0.111,
                    ],
                    [
                      0.149,
                      0,
                    ],
                    [
                      -3.361,
                      -8.738,
                    ],
                    [
                      0.433,
                      -3.149,
                    ],
                    [
                      0.182,
                      -1.816,
                    ],
                    [
                      2.006,
                      -2.643,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.811,
                      1.517,
                    ],
                    [
                      0.383,
                      0.463,
                    ],
                    [
                      1.506,
                      0.648,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      18.553,
                      -13.545,
                    ],
                    [
                      16.706,
                      -11.305,
                    ],
                    [
                      15.023,
                      -6.964,
                    ],
                    [
                      15.807,
                      -0.271,
                    ],
                    [
                      17.6,
                      9.671,
                    ],
                    [
                      13.792,
                      16.896,
                    ],
                    [
                      12.083,
                      27.118,
                    ],
                    [
                      -10.107,
                      24.98,
                    ],
                    [
                      -10.107,
                      15.422,
                    ],
                    [
                      -14.848,
                      6.385,
                    ],
                    [
                      -18.098,
                      -8.327,
                    ],
                    [
                      -17.014,
                      -15.758,
                    ],
                    [
                      -15.26,
                      -21.172,
                    ],
                    [
                      -10.368,
                      -28.23,
                    ],
                    [
                      -6.559,
                      -28.528,
                    ],
                    [
                      -7.419,
                      -15.347,
                    ],
                    [
                      -7.288,
                      -8.468,
                    ],
                    [
                      -4.805,
                      -7.244,
                    ],
                    [
                      1.93,
                      -2.735,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.364,
                  134.717,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -0.701,
                      -0.514,
                    ],
                    [
                      0.903,
                      -1.871,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.7,
                      0.514,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -1.98,
                      -2.101,
                    ],
                    [
                      -0.106,
                      -2.763,
                    ],
                    [
                      1.077,
                      1.727,
                    ],
                    [
                      0.053,
                      3.277,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  42.648,
                  112.156,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.486,
                      -1.529,
                    ],
                    [
                      0.927,
                      -0.323,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      1.486,
                      1.529,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.305,
                      -2.114,
                    ],
                    [
                      0.818,
                      -1.616,
                    ],
                    [
                      -0.13,
                      3.145,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  39.899,
                  104.281,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.205,
                      -3.027,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.762,
                      1.916,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      -2.141,
                      -1.967,
                    ],
                    [
                      1.378,
                      -0.31,
                    ],
                    [
                      -0.152,
                      3.337,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  36.76,
                  95.991,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0.96,
                      1.956,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      -1.43,
                      -2.911,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      0.035,
                      3.355,
                    ],
                    [
                      1.157,
                      -0.443,
                    ],
                    [
                      -2.117,
                      -2.262,
                    ],
                  ],
                  c: false,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  0.773000021542,
                  0.705999995213,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  33.417,
                  87.562,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 127,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 6,
      ty: 3,
      nm: 'Capa 4',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 90,
              s: [
                100,
              ],
            },
            {
              t: 105,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 1,
          k: [
            {
              i: {
                x: 0.667,
                y: 1,
              },
              o: {
                x: 0.333,
                y: 0,
              },
              t: 0,
              s: [
                93,
                103.5,
                9,
              ],
              to: [
                0,
                -4.833,
                -1.5,
              ],
              ti: [
                0,
                4.833,
                1.5,
              ],
            },
            {
              t: 14,
              s: [
                93,
                74.5,
                0,
              ],
            },
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      ip: 0,
      op: 127,
      st: 0,
      bm: 0,
    },
    {
      ddd: 1,
      ind: 7,
      ty: 4,
      nm: 'Capa 1 contornos',
      parent: 6,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 0,
              s: [
                0,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 14,
              s: [
                100,
              ],
            },
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 90,
              s: [
                100,
              ],
            },
            {
              t: 105,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        rx: {
          a: 0,
          k: 0,
          ix: 8,
        },
        ry: {
          a: 0,
          k: 0,
          ix: 9,
        },
        rz: {
          a: 0,
          k: 0,
          ix: 10,
        },
        or: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 7,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.478,
                      1.254,
                    ],
                    [
                      1.695,
                      -0.645,
                    ],
                    [
                      0.143,
                      -1.002,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.396,
                      0.041,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.003,
                      0.341,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -1.358,
                      0.518,
                    ],
                  ],
                  o: [
                    [
                      -0.478,
                      -1.254,
                    ],
                    [
                      -1.283,
                      0.49,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.257,
                      -0.304,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.207,
                      -0.272,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.749,
                      0.75,
                    ],
                    [
                      1.696,
                      -0.645,
                    ],
                  ],
                  v: [
                    [
                      6.712,
                      -4.573,
                    ],
                    [
                      2.777,
                      -5.675,
                    ],
                    [
                      0.473,
                      -3.187,
                    ],
                    [
                      0.473,
                      -3.183,
                    ],
                    [
                      -0.609,
                      -3.031,
                    ],
                    [
                      -2.993,
                      -5.205,
                    ],
                    [
                      -4.012,
                      -5.741,
                    ],
                    [
                      -7.189,
                      -6.223,
                    ],
                    [
                      -2.135,
                      6.32,
                    ],
                    [
                      -0.156,
                      3.348,
                    ],
                    [
                      0.158,
                      2.402,
                    ],
                    [
                      0.195,
                      -0.951,
                    ],
                    [
                      1.001,
                      -1.578,
                    ],
                    [
                      1.005,
                      -1.573,
                    ],
                    [
                      4.507,
                      -1.133,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.629,
                  121.656,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 1',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.05,
                      -0.207,
                    ],
                    [
                      -0.217,
                      -0.308,
                    ],
                    [
                      -0.159,
                      -0.415,
                    ],
                    [
                      -0.022,
                      -0.453,
                    ],
                    [
                      -0.114,
                      -0.259,
                    ],
                    [
                      -0.466,
                      -1.015,
                    ],
                    [
                      0.089,
                      0.192,
                    ],
                    [
                      0.422,
                      0.999,
                    ],
                    [
                      -0.07,
                      0.511,
                    ],
                    [
                      0.146,
                      0.32,
                    ],
                    [
                      0.211,
                      0.88,
                    ],
                  ],
                  o: [
                    [
                      0.088,
                      0.365,
                    ],
                    [
                      0.258,
                      0.366,
                    ],
                    [
                      0.18,
                      0.466,
                    ],
                    [
                      0.014,
                      0.29,
                    ],
                    [
                      0.45,
                      1.022,
                    ],
                    [
                      0.089,
                      0.193,
                    ],
                    [
                      -0.452,
                      -0.986,
                    ],
                    [
                      -0.196,
                      -0.464,
                    ],
                    [
                      0.044,
                      -0.321,
                    ],
                    [
                      -0.353,
                      -0.773,
                    ],
                    [
                      -0.05,
                      -0.207,
                    ],
                  ],
                  v: [
                    [
                      -1.555,
                      -3.578,
                    ],
                    [
                      -1.108,
                      -2.588,
                    ],
                    [
                      -0.241,
                      -1.49,
                    ],
                    [
                      -0.309,
                      -0.237,
                    ],
                    [
                      -0.032,
                      0.577,
                    ],
                    [
                      1.23,
                      3.68,
                    ],
                    [
                      1.516,
                      3.513,
                    ],
                    [
                      0.292,
                      0.496,
                    ],
                    [
                      0.139,
                      -0.774,
                    ],
                    [
                      0.084,
                      -1.604,
                    ],
                    [
                      -1.235,
                      -3.666,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  13.075,
                  101.25,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 2',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.036,
                      0.209,
                    ],
                    [
                      0.394,
                      -0.399,
                    ],
                    [
                      -0.446,
                      -1.111,
                    ],
                    [
                      0.08,
                      0.199,
                    ],
                    [
                      -0.419,
                      0.648,
                    ],
                    [
                      -0.259,
                      0.261,
                    ],
                    [
                      -0.129,
                      0.117,
                    ],
                    [
                      -0.131,
                      -0.768,
                    ],
                  ],
                  o: [
                    [
                      -0.224,
                      -1.308,
                    ],
                    [
                      -0.764,
                      0.775,
                    ],
                    [
                      0.078,
                      0.196,
                    ],
                    [
                      -0.311,
                      -0.775,
                    ],
                    [
                      0.2,
                      -0.309,
                    ],
                    [
                      0.123,
                      -0.123,
                    ],
                    [
                      0.181,
                      -0.163,
                    ],
                    [
                      0.036,
                      0.21,
                    ],
                  ],
                  v: [
                    [
                      1.848,
                      -1.252,
                    ],
                    [
                      -0.247,
                      -0.839,
                    ],
                    [
                      -1.438,
                      2.364,
                    ],
                    [
                      -1.118,
                      2.276,
                    ],
                    [
                      -0.609,
                      0.203,
                    ],
                    [
                      0.051,
                      -0.664,
                    ],
                    [
                      0.439,
                      -1.017,
                    ],
                    [
                      1.527,
                      -1.164,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  13.051,
                  95.622,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 3',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.074,
                      -0.201,
                    ],
                    [
                      -0.959,
                      0.087,
                    ],
                    [
                      0.092,
                      0.972,
                    ],
                    [
                      -0.02,
                      -0.213,
                    ],
                    [
                      0.708,
                      -0.014,
                    ],
                    [
                      0.282,
                      0.76,
                    ],
                  ],
                  o: [
                    [
                      0.355,
                      0.959,
                    ],
                    [
                      0.859,
                      -0.079,
                    ],
                    [
                      -0.02,
                      -0.21,
                    ],
                    [
                      0.082,
                      0.872,
                    ],
                    [
                      -0.744,
                      0.016,
                    ],
                    [
                      -0.073,
                      -0.198,
                    ],
                  ],
                  v: [
                    [
                      -2.432,
                      -0.265,
                    ],
                    [
                      0.195,
                      1.088,
                    ],
                    [
                      2.413,
                      -0.962,
                    ],
                    [
                      2.083,
                      -0.962,
                    ],
                    [
                      0.012,
                      0.762,
                    ],
                    [
                      -2.113,
                      -0.353,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  12.478,
                  95.325,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 4',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 4,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.03,
                      0.211,
                    ],
                    [
                      0.439,
                      -0.338,
                    ],
                    [
                      -0.404,
                      -0.689,
                    ],
                    [
                      0.109,
                      0.184,
                    ],
                    [
                      -0.014,
                      0.397,
                    ],
                    [
                      -0.124,
                      0.189,
                    ],
                    [
                      -0.132,
                      0.062,
                    ],
                    [
                      -0.145,
                      -0.246,
                    ],
                  ],
                  o: [
                    [
                      0.102,
                      -0.734,
                    ],
                    [
                      -0.711,
                      0.549,
                    ],
                    [
                      0.108,
                      0.183,
                    ],
                    [
                      -0.199,
                      -0.34,
                    ],
                    [
                      0.007,
                      -0.232,
                    ],
                    [
                      0.063,
                      -0.129,
                    ],
                    [
                      0.216,
                      -0.17,
                    ],
                    [
                      -0.029,
                      0.208,
                    ],
                  ],
                  v: [
                    [
                      0.89,
                      -0.693,
                    ],
                    [
                      -0.281,
                      -1.079,
                    ],
                    [
                      -0.413,
                      1.244,
                    ],
                    [
                      -0.127,
                      1.077,
                    ],
                    [
                      -0.425,
                      -0.019,
                    ],
                    [
                      -0.264,
                      -0.608,
                    ],
                    [
                      0.028,
                      -0.895,
                    ],
                    [
                      0.57,
                      -0.781,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  10.616,
                  94.15,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 5',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 5,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.088,
                      0.013,
                    ],
                    [
                      -0.147,
                      0.095,
                    ],
                    [
                      -0.043,
                      0.176,
                    ],
                    [
                      0.05,
                      -0.207,
                    ],
                    [
                      0.114,
                      -0.056,
                    ],
                    [
                      0.12,
                      -0.017,
                    ],
                    [
                      -0.021,
                      -0.078,
                    ],
                  ],
                  o: [
                    [
                      0.171,
                      -0.022,
                    ],
                    [
                      0.151,
                      -0.099,
                    ],
                    [
                      0.049,
                      -0.207,
                    ],
                    [
                      -0.029,
                      0.118,
                    ],
                    [
                      -0.11,
                      0.053,
                    ],
                    [
                      -0.09,
                      0.012,
                    ],
                    [
                      0.025,
                      0.095,
                    ],
                  ],
                  v: [
                    [
                      -0.296,
                      0.415,
                    ],
                    [
                      0.204,
                      0.254,
                    ],
                    [
                      0.473,
                      -0.133,
                    ],
                    [
                      0.152,
                      -0.221,
                    ],
                    [
                      -0.023,
                      0.004,
                    ],
                    [
                      -0.385,
                      0.097,
                    ],
                    [
                      -0.501,
                      0.301,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  11.05,
                  93.529,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 6',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 6,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      -0.213,
                      0.015,
                    ],
                    [
                      0.401,
                      0.873,
                    ],
                    [
                      0.757,
                      -0.437,
                    ],
                    [
                      0.105,
                      -1.122,
                    ],
                    [
                      -1.031,
                      0.067,
                    ],
                    [
                      0.213,
                      -0.015,
                    ],
                    [
                      -0.856,
                      0.871,
                    ],
                    [
                      -0.55,
                      0.096,
                    ],
                    [
                      -0.317,
                      -0.246,
                    ],
                    [
                      0.753,
                      -0.05,
                    ],
                  ],
                  o: [
                    [
                      0.782,
                      -0.052,
                    ],
                    [
                      -0.439,
                      -0.957,
                    ],
                    [
                      -0.971,
                      0.56,
                    ],
                    [
                      -0.096,
                      1.03,
                    ],
                    [
                      0.212,
                      -0.014,
                    ],
                    [
                      -1.941,
                      0.126,
                    ],
                    [
                      0.376,
                      -0.382,
                    ],
                    [
                      0.376,
                      -0.067,
                    ],
                    [
                      0.671,
                      0.519,
                    ],
                    [
                      -0.212,
                      0.014,
                    ],
                  ],
                  v: [
                    [
                      0.835,
                      -0.079,
                    ],
                    [
                      2.051,
                      -1.573,
                    ],
                    [
                      -0.427,
                      -1.992,
                    ],
                    [
                      -2.211,
                      0.658,
                    ],
                    [
                      -0.511,
                      2.463,
                    ],
                    [
                      -0.511,
                      2.132,
                    ],
                    [
                      -1.073,
                      -1.029,
                    ],
                    [
                      0.313,
                      -1.946,
                    ],
                    [
                      1.44,
                      -1.768,
                    ],
                    [
                      0.835,
                      -0.41,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  11.26,
                  91.483,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 7',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 7,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.598,
                      7.098,
                    ],
                    [
                      -2.769,
                      -7.033,
                    ],
                    [
                      -2.597,
                      -7.098,
                    ],
                    [
                      2.769,
                      7.033,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  18.512,
                  93.117,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 8',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 8,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.449,
                      6.708,
                    ],
                    [
                      -2.621,
                      -6.643,
                    ],
                    [
                      -2.449,
                      -6.708,
                    ],
                    [
                      2.621,
                      6.643,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  21.726,
                  90.472,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 9',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 9,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      3.243,
                      8.832,
                    ],
                    [
                      -3.46,
                      -8.821,
                    ],
                    [
                      -3.288,
                      -8.886,
                    ],
                    [
                      3.46,
                      8.886,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  11.302,
                  99.46,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 10',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 10,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.309,
                      6.339,
                    ],
                    [
                      -2.481,
                      -6.273,
                    ],
                    [
                      -2.309,
                      -6.339,
                    ],
                    [
                      2.481,
                      6.274,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  16.729,
                  93.116,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 11',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 11,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.736,
                      7.462,
                    ],
                    [
                      -2.908,
                      -7.396,
                    ],
                    [
                      -2.736,
                      -7.463,
                    ],
                    [
                      2.908,
                      7.398,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  20.316,
                  92.456,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 12',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 12,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  v: [
                    [
                      2.282,
                      6.786,
                    ],
                    [
                      -2.798,
                      -6.59,
                    ],
                    [
                      -2.283,
                      -6.786,
                    ],
                    [
                      2.798,
                      6.59,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.952999997606,
                  0.455000005984,
                  0.13300000359,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  24.45,
                  88.702,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 13',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 13,
          mn: 'ADBE Vector Group',
          hd: false,
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [
                      0.312,
                      0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      1,
                      -0.643,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.312,
                      -0.825,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.999,
                      0.643,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                  ],
                  o: [
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.421,
                      -1.112,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      -0.742,
                      0.478,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.421,
                      1.113,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0,
                      0,
                    ],
                    [
                      0.741,
                      -0.476,
                    ],
                  ],
                  v: [
                    [
                      20.715,
                      14.183,
                    ],
                    [
                      5.786,
                      -25.137,
                    ],
                    [
                      4.214,
                      -29.297,
                    ],
                    [
                      1.454,
                      -30.208,
                    ],
                    [
                      -15.533,
                      -19.292,
                    ],
                    [
                      -15.551,
                      -19.259,
                    ],
                    [
                      -19.977,
                      -16.416,
                    ],
                    [
                      -20.714,
                      -14.182,
                    ],
                    [
                      -5.785,
                      25.137,
                    ],
                    [
                      -4.212,
                      29.297,
                    ],
                    [
                      -1.454,
                      30.208,
                    ],
                    [
                      15.533,
                      19.291,
                    ],
                    [
                      15.551,
                      19.26,
                    ],
                    [
                      19.977,
                      16.415,
                    ],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: 'Trazado 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  0.987999949736,
                  0.910000011968,
                  0.910000011968,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  22.908,
                  103.57,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Grupo 14',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 14,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 127,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 0,
      nm: 'Colores 2',
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.667,
                ],
                y: [
                  1,
                ],
              },
              o: {
                x: [
                  0.333,
                ],
                y: [
                  0,
                ],
              },
              t: 100,
              s: [
                100,
              ],
            },
            {
              t: 115,
              s: [
                0,
              ],
            },
          ],
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      w: 160,
      h: 165,
      ip: 55,
      op: 805,
      st: 55,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 4,
      nm: 'Capa de formas 1',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11,
        },
        r: {
          a: 0,
          k: 0,
          ix: 10,
        },
        p: {
          a: 0,
          k: [
            80,
            82.5,
            0,
          ],
          ix: 2,
        },
        a: {
          a: 0,
          k: [
            0,
            0,
            0,
          ],
          ix: 1,
        },
        s: {
          a: 0,
          k: [
            100,
            100,
            100,
          ],
          ix: 6,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'rc',
              d: 1,
              s: {
                a: 0,
                k: [
                  203.348,
                  215.727,
                ],
                ix: 2,
              },
              p: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 4,
              },
              nm: 'Trazado de rectángulo 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false,
            },
            {
              ty: 'st',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 3,
              },
              o: {
                a: 0,
                k: 100,
                ix: 4,
              },
              w: {
                a: 0,
                k: 0,
                ix: 5,
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: 'Trazo 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false,
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [
                  1,
                  1,
                  1,
                  1,
                ],
                ix: 4,
              },
              o: {
                a: 0,
                k: 100,
                ix: 5,
              },
              r: 1,
              bm: 0,
              nm: 'Relleno 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false,
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [
                  7.674,
                  13.363,
                ],
                ix: 2,
              },
              a: {
                a: 0,
                k: [
                  0,
                  0,
                ],
                ix: 1,
              },
              s: {
                a: 0,
                k: [
                  100,
                  100,
                ],
                ix: 3,
              },
              r: {
                a: 0,
                k: 0,
                ix: 6,
              },
              o: {
                a: 0,
                k: 100,
                ix: 7,
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4,
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5,
              },
              nm: 'Transformar',
            },
          ],
          nm: 'Rectángulo 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false,
        },
      ],
      ip: 0,
      op: 750,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
};
